module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#logout",
      toString: function () {
        return this.url;
      }
    }